import GLightbox from 'glightbox';

/* eslint-disable no-unused-vars */
const imageGalleryLightbox = GLightbox({
  touchNavigation: true,
  loop: false,
  zoomable: false,
  svg: {
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.921 33.203"><path fill="none" stroke="currentColor" stroke-width="2" d="m.71.704 31.5 31.795m0-31.795L.71 32.499"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.565 15.327"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M.5 7.663h29.565"/><path d="m23.109.704 6.956 6.96-6.957 6.957"/></g></svg>',
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.565 15.327"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M30.065 7.664H.5"/><path d="M7.456 14.623.5 7.663 7.457.706"/></g></svg>',
  },
});
/* eslint-enable no-unused-vars */
